module.exports = __webpack_public_path__ + "72f8ba29614b0e163d3b73c561c93aff.gif";